import React from "react";
import { NakiNigunArtistEditNameLoaderTemplate } from "themes/administration/naki-nigun/components";

const NakiNigunArtistEditNameLoader = (props) => {
    return <NakiNigunArtistEditNameLoaderTemplate {...props} />;
};

export default NakiNigunArtistEditNameLoader;
